import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9f93cb9e")

_pushScopeId("data-v-9f93cb9e")
const _hoisted_1 = { class: "main-bg" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.iframeUrl)
      ? (_openBlock(), _createBlock("iframe", {
          key: 0,
          class: "page-iframe",
          frameborder: "0",
          src: _ctx.iframeUrl,
          width: "100%",
          height: "100%",
          onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args)))
        }, null, 40, ["src"]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
})